export const mountFabricCanvas = (host) => {
    if (!host) return null;

    const canvas = document.createElement("canvas");
    canvas.className = "wbFabricCanvasElement";
    host.replaceChildren(canvas);

    return canvas;
};

export const clearFabricCanvasHost = (host) => {
    if (host?.isConnected) host.replaceChildren();
};
